import styled from 'styled-components';

import theme from '$/assets/theme';

const StyledIcon = styled.span`
  width: 16px;
  color: ${theme.colors.grey5};
`;

export default StyledIcon;
